import BreadCrumb from "components/Common/BreadCrumb";
import TableContainer from "components/Common/TableContainer";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Row,
} from "reactstrap";
import { createSelector } from "reselect";
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from "use-query-params";
import LabelWrapper from "components/Common/LabelWrapper";
import { useRole } from "components/Hooks/UserHooks";
import {
  AGENCY_APP_NAME_OPTION,
  AGENCY_EVENT_ACTION_TYPE_OPTION,
  COLOR_AGENCY_EVENT_ACTION_TYPE,
  COLOR_USER_REAL_GUEST,
  COLOR_USER_TYPE_LOG,
  ENUM_USER_TYPE_LOG,
  getOptionImage,
  getPlatFormImage,
  GUEST_MODE_OPTION,
  LIST_AGENCY_OPTION,
  LIST_CHANNEL_OPTION,
  LIST_OPTION_BAR_LIST_OPEN_STATUS,
  LIST_OPTION_OS,
  USER_REAL_GUEST_OPTION,
  USER_TYPE_LOG_OPTION,
} from "helpers/constans";
import CountUp from "react-countup";
import { formatDateStringToKorea, formatDateStringToUTC } from "helpers/format";
import CollapseFilter from "components/Common/CollapseFilter";
import ModalMultiPreview from "components/Common/ModalMultiPreview";
import DropdownStatusNew from "components/Common/DropdownStatusNew";
import ModalPreview from "components/Common/ModalPreview";
import moment from "moment";
import DatePickerCustom from "components/Common/DatePickerCustom";
import DropdownOption from "components/Common/DropdownOption";
import DropdownChannel from "components/Common/DropdownChannel";
import DropdownAsyncCampaign from "components/Common/DropdownAsyncCampaign";
import { getAgencyTrackingLogList } from "store/agencyTrackingLog/thunk";
import countries from "helpers/countries";
import countryApi from "api/countryApi";
import DropdownAsyncAgency from "components/Common/DropdownAsyncAgency";
import DropdownOptionNew from "components/Common/DropdownOptionNew";
import DropdownOptionImage from "components/Common/DropdownOptionImage";
import CopyWrapper from "components/Common/CopyWrapper";
import IPHONE_MODELS from "helpers/iphone_models";
import avatar1 from "../../../assets/images/users/ic_defaul_avatar2.png";
import { capitalizeFirstLetter } from "utils";
import DropdownCountries from "components/Common/DropdownCountries";

interface Option {
  label: string;
  value: string;
}

const TYPE_SELECT_DEFAULT: string = "created_at";

registerLocale("en", en);
registerLocale("ko", ko);

const AgencyInstall = () => {
  const { t, i18n } = useTranslation();
  const { userPermissions } = useRole();

  const [query, setQuery]: any = useQueryParams({
    time_request: withDefault(NumberParam, 0),
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 30),
    keyword: withDefault(StringParam, ""),
    platform: withDefault(StringParam, ""),
    agency: withDefault(StringParam, ""),
    campaign: withDefault(StringParam, ""),
    // channel: withDefault(StringParam, ""),
    app_name: withDefault(StringParam, ""),
    action_type: withDefault(StringParam, ""),
    country: withDefault(StringParam, "KR"),
    start_date: withDefault(StringParam, ""),
    end_date: withDefault(StringParam, ""),
    sort_by: withDefault(StringParam, "created_at"),
    order_by: withDefault(StringParam, "DESC"),
  });

  const [linkImage, setLinkImage] = useState<any>(null);
  const [listCountry, setListCountry] = useState<any>([]);

  const [countrySearch, setCountrySearch] = useState<any>("kr");
  const [dateSearch, setDateSearch] = useState<any[]>([
    query?.start_date
      ? moment(query?.start_date || "", "Y-MM-DD").toDate()
      : null,
    query?.end_date ? moment(query?.end_date || "", "Y-MM-DD").toDate() : null,
  ]);
  const [startDate, endDate] = dateSearch;

  const [keywordSearch, setKeywordSearch] = useState<string>(
    query?.keyword || ""
  );
  const [oSSearch, setOSSearch] = useState<any | null>(
    LIST_OPTION_OS?.filter(
      (item) => String(item?.value) === String(query?.platform)
    )[0]?.value || ""
  );
  const [statusSearch, setStatusSearch] = useState<Option | any>(
    LIST_OPTION_BAR_LIST_OPEN_STATUS?.find(
      (item) => item?.value === query?.status
    )?.value || ""
  );
  const [agencySearch, setAgencySearch] = useState<Option | any>(
    LIST_AGENCY_OPTION?.find((item) => item?.value === query?.agencyId)
      ?.value || {
      label: t("All Filter"),
      value: "all",
    }
  );
  const [campaignSearch, setCampaignSearch] = useState<Option | any>(
    LIST_AGENCY_OPTION?.find((item) => item?.value === query?.campaignId)
      ?.value || {
      label: t("All Filter"),
      value: "all",
    }
  );
  const [channelSearch, setChannelSearch] = useState<Option | any>(
    LIST_CHANNEL_OPTION?.find((item) => item?.value === query?.channel)
      ?.value || ""
  );
  const [appNameSearch, setAppNameSearch] = useState<Option | any>(
    AGENCY_APP_NAME_OPTION?.find((item) => item?.value === query?.app_name)
      ?.value || ""
  );
  const [actionTypeSearch, setActionTypeSearch] = useState<Option | any>(
    AGENCY_EVENT_ACTION_TYPE_OPTION?.find(
      (item) => item?.value === query?.action_type
    )?.value || ""
  );

  const dispatch: any = useDispatch();
  const selectLayoutState = (state: any) => state.AgencyTrackingLog;
  const AgencyProperties = createSelector(selectLayoutState, (state) => ({
    lstTrackingLog: state.lstTrackingLog,
    isTrackingLogLoading: state.isTrackingLogLoading,
    isTrackingLogSuccess: state.isTrackingLogSuccess,
    error: state.error,
  }));

  // Inside your component
  const { lstTrackingLog, isTrackingLogLoading } =
    useSelector(AgencyProperties);

  function loadTableData() {
    dispatch(getAgencyTrackingLogList(query));
  }

  const searchData = () => {
    setQuery({
      ...query,
      keyword: keywordSearch,
      channel: channelSearch,
      agency: agencySearch?.value,
      campaign: campaignSearch?.value,
      app_name: appNameSearch,
      action_type: actionTypeSearch,
      platform: oSSearch || "",
      status: statusSearch,
      country: countrySearch?.value || "",
      // start_date: startDate
      //   ? moment(new Date(startDate)).startOf("day").format("Y-MM-DD HH:mm:ss")
      //   : "",
      // end_date: endDate ? moment(new Date(endDate)).endOf("day").format("Y-MM-DD HH:mm:ss") : "",
      start_date: startDate
        ? formatDateStringToUTC(
          moment(new Date(startDate))
            .startOf("day")
            .format("Y-MM-DD HH:mm:ss")
        )
        : "",
      end_date: endDate
        ? formatDateStringToUTC(
          moment(new Date(endDate)).endOf("day").format("Y-MM-DD HH:mm:ss")
        )
        : "",
      sort_by: TYPE_SELECT_DEFAULT,
      page: 1,
      time_request: +new Date(),
    });
  };

  const resetData = () => {
    setQuery(
      {
        keyword: "",
        channel: "",
        app_name: "",
        action_type: "",
        platform: "",
        status: "",
        country: "KR",
        start_date: "",
        end_date: "",
        sort_by: TYPE_SELECT_DEFAULT,
        time_request: +new Date(),
      },
      "push"
    );

    setKeywordSearch((_prev) => "");
    setStatusSearch((_prev: any) => "");
    setChannelSearch((_prev: any) => "");
    setAppNameSearch((_prev: any) => "");
    setActionTypeSearch((_prev: any) => "");
    setCampaignSearch({
      label: t("All Filter"),
      value: "all",
    });
    setAgencySearch({
      label: t("All Filter"),
      value: "all",
    });
    setOSSearch(null);
    setCountrySearch((_prev: any) => ({ value: "KR", label: "" }))
    setDateSearch([null, null]);
  };

  // Column
  const columns = useMemo(
    () => [
      {
        Header: t("No."),
        thWidth: 80,
        Cell: ({ ...props }) => {
          return (
            <div style={{ minWidth: "60px" }}>
              {lstTrackingLog?.meta?.total -
                ((query?.page - 1) * query?.limit + props?.row?.index)}
            </div>
          );
        },
      },
      {
        Header: t("Action Type"),
        accessor: "action_type",
        thWidth: 150,
        thClass: "text-center whitespace-nowrap",
        Cell: (cell: any) => {
          return (
            <div className="text-center" style={{ minWidth: 80 }}>
              <span
                className={`rounded-pill badge bg-${COLOR_AGENCY_EVENT_ACTION_TYPE[cell?.value] || "secondary"
                  }`}
              >
                {t(
                  AGENCY_EVENT_ACTION_TYPE_OPTION?.find(
                    (item: any) => item?.value === cell?.value
                  )?.label || ""
                )}
              </span>
            </div>
          );
        },
      },
      {
        Header: t("App"),
        accessor: "app_name",
        thClass: "whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 150,
        Cell: (cell: any) => {
          const item = cell?.value;
          let imgAppName = getOptionImage(item);

          return (
            item && (
              <div className="d-flex align-items-center whitespace-nowrap">
                {imgAppName ? (
                  <div style={{ width: "25px" }} className="me-1">
                    {imgAppName ? (
                      <img
                        src={imgAppName}
                        width={20}
                        height={20}
                        alt="platform"
                      />
                    ) : (
                      <span
                        className={`bg-secondary`}
                        style={{
                          width: "20px",
                          height: "20px",
                          borderRadius: "3px",
                        }}
                      ></span>
                    )}
                  </div>
                ) : (
                  ""
                )}
                <div>
                  {t(
                    AGENCY_APP_NAME_OPTION?.find(
                      (item: any) => item?.value === cell?.value
                    )?.label || ""
                  )}
                </div>
              </div>
            )
          );
        },
      },
      {
        Header: `${t("Campaign")}`,
        accessor: "CampaignName",
        filterable: false,
        sortable: false,
        thWidth: 140,
        thClass: "text-center whitespace-nowrap",
        Cell: (cell: any) => {
          const item: any = cell?.row?.original?.campaign;
          return (
            <div className="text-center" style={{ minWidth: '120px' }}>
              {item ? <><div>{item?.name}</div>
                <div className="text-primary">{item?.referral_code}</div> </> : <div>-</div>}
            </div>
          );
        },
      },
      {
        Header: `${t("Agency")}`,
        accessor: "AgencyName",
        filterable: false,
        sortable: false,
        thWidth: 140,
        thClass: "text-center whitespace-nowrap",
        Cell: (cell: any) => {
          const item: any = cell?.row?.original?.agency;
          return (
            <div className="text-center" style={{ minWidth: '120px' }}>
              {item ? <><div>{item?.agency_name}</div>
                <div className="text-primary">{item?.referral_code}</div> </> : <div>-</div>}
            </div>
          );
        },
      },
      // {
      //   Header: t("Channel"),
      //   accessor: "channel",
      //   filterable: false,
      //   sortable: false,
      //   thWidth: 140,
      //   thClass: "whitespace-nowrap",
      //   Cell: (cell: any) => {
      //     return (
      //       <div style={{ minWidth: 100 }}>
      //         {t(
      //           LIST_CHANNEL_OPTION?.find(
      //             (item: any) => item?.value === cell?.value
      //           )?.label || "-"
      //         )}
      //       </div>
      //     );
      //   },
      // },
      {
        Header: t("User Type"),
        accessor: "user_type",
        filterable: false,
        sortable: false,
        thWidth: 140,
        thClass: "text-center whitespace-nowrap",
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          const _type = item?.user?.type;
          return (
            <div className="text-center" style={{ minWidth: 80 }}>
              {_type ? <span
                  className={`rounded-pill badge bg-${COLOR_USER_TYPE_LOG[_type] || "secondary"}`}
                >
                  {t(
                    USER_TYPE_LOG_OPTION?.find(
                      (item: any) => String(item?.value) === String(_type)
                    )?.label || ""
                  )}
                </span> : "-"
              }
            </div>
          );
        },
      },
      {
        Header: t("Operation Mode"),
        accessor: "is_guest_mode",
        filterable: false,
        sortable: false,
        thWidth: 140,
        thClass: "text-center whitespace-nowrap",
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          const is_guest_mode = item?.user?.is_guest_mode;
          return (
            <div className="text-center" style={{ minWidth: 120 }}>
              {String(item?.user_type) === String(ENUM_USER_TYPE_LOG.NORMAL_USER) ? <span
                className={`rounded-pill badge bg-${COLOR_USER_REAL_GUEST[is_guest_mode] || "secondary"
                  }`}
              >
                {t(GUEST_MODE_OPTION?.find(
                  (item: any) => String(item?.value) === String(is_guest_mode)
                )?.label || ""
                )}
              </span> : <>-</>}
            </div>
          );
        },
      },
      {
        Header: t("Photo"),
        accessor: "user.avatar",
        thClass: "text-center whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 80,
        Cell: (cell: any) => {
          const uuid = cell?.row?.original?.udid_2;
          const avatar = cell?.value ? cell?.value : (uuid ? avatar1 : '' )
          return (
            <>
              <div className="w-100 text-center " style={{ minWidth: "60px" }}>
                <div
                  style={{ width: "45px" }}
                  className="m-auto cursor-pointer"
                  onClick={() => {
                    if(cell?.value) {
                      setLinkImage({url: cell?.value});
                    }
                  }}
                >
                  {
                    avatar ? (
                      <img
                        src={cell?.value ?? avatar1}
                        className="rounded-circle avatar-sm"
                        alt="thumbnail"
                        onError={({ currentTarget }) => {
                          currentTarget.onerror = null; // prevents looping
                          currentTarget.src = avatar1;
                        }}
                      />
                    ) : '-'
                  }
                </div>
              </div>
            </>
          )
        },
      },

      {
        Header: t("Nickname"),
        accessor: "user.nickname",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 180,
        Cell: (cell: any) => {
          return (
            cell?.value ? (
              <div className="cursor-pointer">
                <CopyWrapper contentCopy={cell?.value}>
                  {`${cell?.value}`}
                </CopyWrapper>
              </div>
            ) : '-'
          );
        },
      },

      {
        Header: t("Email"),
        accessor: "user.email",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 180,
        Cell: (cell: any) => {
          return (
            cell?.value ? (
              <div className="cursor-pointer" style={{ minWidth: '130px' }}>
                <CopyWrapper contentCopy={cell?.value}>
                  {`${cell?.value}`}
                </CopyWrapper>
              </div>
            ) : '-'
          );
        },
      },
      {
        Header: t("Platform"),
        accessor: "user.provider",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 140,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          const isGuest = !!(String(item?.user?.type) === ENUM_USER_TYPE_LOG.GUEST);
          let platform = item?.user?.provider;
          let imgPlatform = getPlatFormImage(platform);
          if (platform === "guest" || (platform === "default" && isGuest)) {
            platform = '-';
          } else if (platform === "default") {
            platform = 'Email'
          }

          return (
            <div className="d-flex flex-column gap-1" style={{ minWidth: '100px' }}>
              <div className="cursor-pointer d-flex gap-2 align-items-center whitespace-nowrap">
                {
                  (platform && platform !== '-') ? (
                    <>
                      <div style={{ width: "25px" }}>
                        {(imgPlatform) && (
                          <img
                            src={imgPlatform}
                            width={25}
                            height={25}
                            alt="platform"
                          />
                        )}
                      </div>
                      <div className="cursor-pointer">
                        {t(
                          capitalizeFirstLetter(platform)
                        )}
                      </div>
                    </>
                  ) : <div className="text-center">-</div>
                }
              </div>
            </div>
          );
        },
      },
      {
        Header: t("OS"),
        accessor: "",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 140,
        Cell: (cell: any) => {
          const deviceOS = cell?.row?.original?.device_os;
          let imgOS = getPlatFormImage(deviceOS);

          return (
            deviceOS && (
              <div
                className="d-flex align-items-center"
                style={{ minWidth: "110px" }}
              >
                {imgOS ? (
                  <div style={{ width: "25px" }} className="me-1">
                    {imgOS ? (
                      <img src={imgOS} width={20} height={20} alt="platform" />
                    ) : (
                      <span
                        className={`bg-secondary`}
                        style={{
                          width: "20px",
                          height: "20px",
                          borderRadius: "3px",
                        }}
                      ></span>
                    )}
                  </div>
                ) : (
                  ""
                )}
                <div>
                  {t(
                    LIST_OPTION_OS?.find((item) => item?.value === deviceOS)
                      ?.label ?? ""
                  )}
                </div>
              </div>
            )
          );
        },
      },
      // {
      //   Header: t("Device Name"),
      //   accessor: "device_model",
      //   thWidth: 150,
      //   thClass: "whitespace-nowrap",
      //   Cell: (cell: any) => {
      //     return (
      //       cell?.value && (
      //         <div className="cursor-pointer" style={{ width: 150 }}>
      //           {t(`${cell?.value}`)}
      //         </div>
      //       )
      //     );
      //   },
      // },
      {
        Header: t("Device Model"),
        accessor: "device_model",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 160,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          let deviceModel = item?.device_model;
          const os = item?.device_os;

          if (os === "ios") {
            deviceModel = deviceModel
              ? IPHONE_MODELS[deviceModel as keyof typeof IPHONE_MODELS] ??
                deviceModel
              : "";
          }

          return (
            deviceModel && (
              <div className="cursor-pointer" style={{minWidth: 140}}>{t(`${deviceModel}`)}</div>
            )
          );
        },
      },

      {
        Header: t("Manufacturer"),
        accessor: "manufacturer",
        filterable: true,
        sortable: false,
        thWidth: 170,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          const manufacturer = cell?.row?.original?.device_manufacturer;
          return (
            (
              <div className="cursor-pointer" style={{ minWidth: "150px" }}>
                {manufacturer || '-'}
              </div>
            )
          );
        },
      },
      {
        Header: t("App Version"),
        accessor: "app_version",
        thWidth: 150,
        thClass: "whitespace-nowrap text-end",
        Cell: (cell: any) => {
          const appBuild: any = cell?.row?.original?.appbuild;
          return (
            cell?.value && (
              <div className="cursor-pointer text-end" style={{ width: 120 }}>
                {t(`${cell?.value} ${appBuild ? `(${appBuild})` : ""}`)}
              </div>
            )
          );
        },
      },
      {
        Header: t("Language"),
        accessor: "lang",
        thWidth: 150,
        thClass: "whitespace-nowrap text-end",
        Cell: (cell: any) => {
          return (
            cell?.value && (
              <div className="cursor-pointer text-end" style={{ width: 80 }}>
                {t(`${cell?.value}`)}
              </div>
            )
          );
        },
      },
      {
        Header: t("Ip Address"),
        accessor: "ip",
        thWidth: 150,
        thClass: "whitespace-nowrap text-end",
        Cell: (cell: any) => {
          return (
            cell?.value && (
              <div className="cursor-pointer text-end" style={{ width: 120 }}>
                {cell?.value}
              </div>
            )
          );
        },
      },
      {
        Header: t("Country"),
        accessor: "country",
        thClass: "whitespace-nowrap",
        filterable: true,
        sortable: false,
        Cell: (cell: any) => {
          const countryCode = cell?.row?.original?.country_code;
          const country = countries.find((item) => item?.code == countryCode);

          return (
            countryCode && (
              <div
                className="d-flex flex-column gap-1"
                style={{ minWidth: "130px" }}
              >
                {
                  <div className="cursor-pointer d-flex gap-2 align-items-center ">
                    {country && (
                      <>
                        <img
                          src={country?.flags}
                          width={20}
                          height={20}
                          alt="profile"
                        />
                        <div className="cursor-pointer">
                          {i18n?.language == "ko"
                            ? country?.name_korea
                            : country?.name}
                        </div>
                      </>
                    )}
                  </div>
                }
              </div>
            )
          );
        },
      },
      {
        Header: t("Region"),
        accessor: "region",
        thWidth: 200,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          return (
            cell?.value && (
              <div className="cursor-pointer" style={{ width: 120 }}>
                {t(`${cell?.value}`)}
              </div>
            )
          );
        },
      },
      {
        Header: t("TimeZone"),
        accessor: "timezone",
        thWidth: 150,
        thClass: "whitespace-nowrap text-end",
        Cell: (cell: any) => {
          return (
            cell?.value && (
              <div className="cursor-pointer text-end" style={{ width: 80 }}>
                {`${cell?.value}`}
              </div>
            )
          );
        },
      },
      {
        Header: t("Action Date"),
        accessor: "action_date",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const lastLoginTime = cell?.row?.original?.action_date;
          const date = formatDateStringToKorea(lastLoginTime);

          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "100px" }}>
              <span>
                <span>{arrDate?.[0] || ""}</span> <br />{" "}
                <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
              </span>
            </div>
          );
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [i18n?.language, lstTrackingLog?.meta?.total, query?.page]
  );

  const handleChangePage = useCallback((page: any) => {
    setQuery({ page: page + 1 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeSorting = useCallback((sortBy: any) => {
    setQuery((_prev: any) => {
      return { ..._prev, ...sortBy };
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangePicker = (values: any[] = []) => {
    setDateSearch((_prev: any) => values);
  };

  // Begin::Delete
  const onCloseImageClick = () => {
    setLinkImage(null);
  };

  useEffect(() => {
    loadTableData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, JSON.stringify(query)]);

  useEffect(() => {
    const handleCallAllOption = async () => {
      try {
        const [resCountry]: any = await Promise.all([
          countryApi.countries({ page: 1, limit: 2000 }),
        ]);
        setListCountry((_prev: any) => resCountry?.data || []);
        
        if (query?.country) {
          const _country = resCountry?.data?.find(
            (_c: any) => String(_c?.code) === String(query?.country)
          );
          setCountrySearch((_prev: any) =>
            _country ? { value: _country?.code, label: _country?.name } : null
          );
        }
      } catch (error: any) {
        return error;
      }
    };

    handleCallAllOption();
  }, []);

  useEffect(() => {
    document.title = `${t("Event Tracking Logs")} | Baive`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t("Event Tracking Logs")} pageTitle={t("Home")} />
          <Row>
            <Col lg={12}>
              <Card
                id="customerList"
                style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
              >
                <CardHeader className="border-0">
                  <div className="d-block d-xl-flex justify-content-between align-items-start">
                    <div
                      className="d-flex w-100 flex-wrap gap-3 gap-md-2 menu-card-statistics justify-content-start mb-3 mb-xl-2 position-relative"
                      style={{ maxWidth: "100%" }}
                    >
                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Total Install")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={lstTrackingLog?.meta?.total || 0}
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>

                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Total iOS")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={
                                      lstTrackingLog?.meta?.summary
                                        ?.total_ios || 0
                                    }
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>

                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Total Android")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={
                                      lstTrackingLog?.meta?.summary
                                        ?.total_android || 0
                                    }
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </div>
                  </div>
                </CardHeader>

                <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                  <CollapseFilter>
                    <Row className="g-4 align-items-center mt-0 mt-md-2">
                      <Col
                        sm={12}
                        md={4}
                        xl={4}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={t("Keyword")}
                          isShow={!!keywordSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Keyword")}...`}
                            value={keywordSearch}
                            onChange={(e) => setKeywordSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={4}
                        xl={4}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper label={t("Agency")} isShow={true}>
                          <DropdownAsyncAgency
                            name="agency_id"
                            onChangeSelect={(event: any) => {
                              setAgencySearch(event);
                            }}
                            isMulti={false}
                            placeholder={`${t("Select Agency")}...`}
                            isShowIconCheck={false}
                            listCheckedUsers={agencySearch}
                            isAllOption={true}
                            isNotBelongToAgency={true}
                            isClearable={false}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={4}
                        xl={4}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper label={t("Campaign")} isShow={true}>
                          <DropdownAsyncCampaign
                            name="campaign"
                            onChangeSelect={(event: any) =>
                              setCampaignSearch(event)
                            }
                            isMulti={false}
                            placeholder={`${t("Select Campaign")}...`}
                            isShowIconCheck={false}
                            isAllOption={true}
                            listCheckedCampaign={campaignSearch}
                            isClearable={false}
                            isNotBelongToCampaign={true}
                          />
                        </LabelWrapper>
                      </Col>

                      {/* <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper label={t("Channel")} isShow={true}>
                          <DropdownChannel
                            name="channel"
                            placeholder={`${t("Channel")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={channelSearch}
                            onChangeSelect={(e: any) => {
                              setChannelSearch(e?.value);
                            }}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                          />
                        </LabelWrapper>
                      </Col> */}

                      <Col
                        sm={12}
                        md={4}
                        xl={4}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper label={t("OS")} isShow={true}>
                          <DropdownOptionImage
                            name="os"
                            dataList={LIST_OPTION_OS || []}
                            placeholder={`${t("OS")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={oSSearch || ""}
                            onChangeSelect={(e: any) => setOSSearch(e?.value)}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={4}
                        xl={4}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("App")} isShow={true}>
                          <DropdownOptionNew
                            name="app_name"
                            dataList={AGENCY_APP_NAME_OPTION || []}
                            placeholder={`${t("Select App Name")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={appNameSearch}
                            onChangeSelect={(e: any) =>
                              setAppNameSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            lstImage={true}
                            hideSelectedOptions={false}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={4}
                        xl={4}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper
                          label={t("Event Action Type")}
                          isShow={true}
                        >
                          <DropdownStatusNew
                            name="status"
                            dataList={AGENCY_EVENT_ACTION_TYPE_OPTION || []}
                            placeholder={`${t("Select Status")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={actionTypeSearch}
                            onChangeSelect={(e: any) =>
                              setActionTypeSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_AGENCY_EVENT_ACTION_TYPE}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Country")} isShow={true}>
                          <DropdownCountries
                            name="country"
                            dataList={listCountry || []}
                            placeholder={""}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={countrySearch || null}
                            onChangeSelect={(e: any) => setCountrySearch(e)}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            // isDefaultKorea={true}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-sm-4 mt-md-3 mt-3 date-picker-wrapper-custom"
                      >
                        <LabelWrapper
                          label={t("Date")}
                          isShow={!!startDate || !!endDate}
                        >
                          <DatePickerCustom
                            startDate={startDate || null}
                            endDate={endDate || null}
                            onChangePicker={handleChangePicker}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={12}
                        xl={12}
                        xxl={12}
                        className="hstack gap-1 justify-content-center justify-content-md-end mt-sm-4 mt-md-3"
                      >
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary me-1"
                            onClick={searchData}
                          >
                            <i className="ri-search-line align-bottom me-1"></i>{" "}
                            {t("Button Search")}
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary fs-14"
                            onClick={resetData}
                          >
                            <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                            {t("Button Reset")}
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </CollapseFilter>
                </div>
                <CardBody className="pt-3">
                  <div>
                    <TableContainer
                      className="custom-header-css"
                      divClass="table-responsive table-card"
                      tableClass="align-middle table-bordered-dashed"
                      theadClass="table-light text-muted"
                      columns={columns}
                      data={
                        lstTrackingLog?.list?.length ? lstTrackingLog?.list : []
                      }
                      customPageSize={query.limit}
                      customPageIndex={query.page - 1}
                      totalRecords={lstTrackingLog?.meta?.total}
                      customPageCount={Math.ceil(
                        Number(lstTrackingLog?.meta?.total) /
                        Number(query.limit)
                      )}
                      handleChangePage={handleChangePage}
                      manualSorting={true}
                      sorting={{
                        sort_by: query.sort_by,
                        order_by: query.order_by,
                      }}
                      handleChangeSorting={handleChangeSorting}
                      isLoading={isTrackingLogLoading}
                    />
                  </div>
                  <ToastContainer closeButton={false} limit={1} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        <ModalPreview
          type={linkImage?.isVideo ? "VIDEO" : "IMAGE"}
          isOpen={!!linkImage?.url}
          url={linkImage?.url}
          content={linkImage?.content}
          onClose={() => onCloseImageClick()}
        />

        <ModalMultiPreview
          isOpen={!!linkImage?.urls}
          urls={linkImage?.urls || []}
          content={linkImage?.content}
          onClose={() => onCloseImageClick()}
        />
      </div>
    </React.Fragment>
  );
};

export default AgencyInstall;
